import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index/Index.vue'
import Stable from '../pages/Stable/Stable.vue'
import Trend from '../pages/Trend/Trend.vue'
import Transient from '../pages/Transient/Transient.vue'
import Realtime from '../pages/Realtime/Realtime.vue'
import Device from '../pages/Device/Device.vue'
import History from '../pages/History/History.vue'
import Speed from '../pages/Speed/Speed.vue'
import Event from '../pages/Event/Event.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '/Stable',
      children: [
        {
          path: '/Stable',
          name: 'Stable',
          component: Stable
        }, {
          path: '/Trend',
          name: 'Trend',
          component: Trend
        }, {
          path: '/Transient',
          name: 'Transient',
          component: Transient
        }, {
          path: '/Realtime',
          name: 'Realtime',
          component: Realtime
        }, {
          path: '/Device',
          name: 'Device',
          component: Device
        }, {
          path: '/History',
          name: 'History',
          component: History
        }, {
          path: '/Speed',
          name: 'Speed',
          component: Speed
        }, {
          path: '/Event',
          name: 'Event',
          component: Event
        }
      ]
    }, {
      title: '登录',
      path: '/Login',
      component: () => import('../pages/Login/Login.vue')
    }, {
      title: '以太网连接失败',
      path: '/UdpErr',
      component: () => import('../pages/Udp/Err/Err.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js